import SeoPage from "../components/SeoPage";

export default function UIUX() {
  return (
    <SeoPage
      title="UI UX Design Services | Arviko"
      description="Professional UI UX design services for modern applications."
      heading="UI UX Design Services"
    >
      <p>
        We design intuitive and user-friendly digital experiences.
      </p>
    </SeoPage>
  );
}